import './styles.css';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RibbonsUtil from "../../utils/RibbonsUtil";
import InfiniteList from '../../components/InfiniteListNew';
import ButtonFilter from '../../components/ButtonFilter';
import RibbonGrid from '../../components/RibbonGridNew';
import {setMetricsEvent} from '../../actions/metrics';
import Utils, {setReloadMisContenidos, getReloadMisContenidos, showSoccerWorldCup} from '../../utils/Utils';
import asset from "../../requests/apa/Asset";
import Device from "../../devices/device";
import {getLinksFromNavConfiguration} from "../../components/Header";
import LayersControl from '../../utils/LayersControl';
import { MUNDIALSOCCERMATCHER, MUNDIALSOCCERTEAMS} from '../../components/RibbonNew/constants.js';
import {
  RibbonsObserver,
  LiveObserver,
  UpdateCardFromRibbonUserObserver,
  ADD_CARD,
  DELETE_CARD,
  UPDATE_CARD
} from '../../components/PersistentMiniEpg/MiniObserver'
import {
  showModal,
  MODAL_FILTER,
  MODAL_RECORD_SERIES_CONTENT
} from '../../actions/modal';

import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import Translator from "../../requests/apa/Translator";
import * as api from "../../requests/loader";
import store from '../../store';
import settings from '../../devices/all/settings';
import { playFullMedia } from '../../actions/playmedia';

import AAFPlayer from 'src/AAFPlayer/AAFPlayer';
/*
import * as playerConstants from '../../utils/playerConstants';
import getAppConfig from '../../config/appConfig';
import { playPipMedia } from "../../actions/playmedia";

*/
class Home extends Component {
  constructor(props) {
    super(props);
    this.keys = Device.getDevice().getKeys();
    this.userHash = this.props.user.session_userhash || '';
    let showRibbonWhenMount;
    if (LoadingIptvOttFlow.isToogleLevelsDelay()) {
      showRibbonWhenMount = typeof LoadingIptvOttFlow.isEnableRibbons() === 'boolean' ? LoadingIptvOttFlow.isEnableRibbons() : false;
    } else {
      showRibbonWhenMount = true;
    }
    this.state = {
      ribbons: [],
      user_status: 'anonymous',
      infiniteList: false,
      ribbonsTypeMenu: 'home',
      showRibbonWhenMount,
      buttonFilter: false,
      order: [],
      orderItems: [],
      prefixValidate: false
    };
    this.ribbonsCategories = RibbonsUtil.getRibbonsCategories(props.code, props.nodes);
    this.groupId_focused = null;

    this.device = Device.getDevice().getPlatform();
    this.toggleFunctions = Utils.getToggleFunctionsFromMetadata();
    this.updateShowRibbonWhenMount = this.updateShowRibbonWhenMount.bind(this);
    this.onModalFilter = this.onModalFilter.bind(this);
    this.updateOrder = this.updateOrder.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.prefixCode = props.code;
  }

  shouldComponentUpdate(newProps, newState) {
    //console.log("[HOME] shouldComponentUpdate", newProps, newState);
    return (
      JSON.stringify(this.state) !== JSON.stringify(newState)
    );
  }

  updateShowRibbonWhenMount(value) {
    const {showRibbonWhenMount} = this.state;
    if (showRibbonWhenMount !== value) {
      LoadingIptvOttFlow.setIsEnabled(true);
      this.setState({
          showRibbonWhenMount: true
        }, () => this.initRequests()
      );
    }
  }

  updateStatePlayerModalRecordings(){
    store.dispatch(playFullMedia({modalRecordSeriesContent: false}));
  }

  componentDidMount() {
    const {showRibbonWhenMount} = this.state;
    RibbonsObserver.subscribe(this.updateShowRibbonWhenMount);
    UpdateCardFromRibbonUserObserver.subscribe(this.updateCardFromRibbonUser);
    if (showRibbonWhenMount) {
      this.initRequests();
    }
    Utils.addPageAction('home');
    
    this.addEventListeners();
  }

  componentWillUnmount() {
    RibbonsObserver.unsubscribe(this.updateShowRibbonWhenMount);
    UpdateCardFromRibbonUserObserver.unsubscribe(this.updateCardFromRibbonUser);
    this.removeEventListeners()
  }


  async componentWillReceiveProps(nextProps) {
    const { modalRecordSeriesContent = false } = store.getState().player;
    //console.log("_____",this.getInfoMetric(this.props.user));
    console.log("[HOME] componentWillReceiveProps", nextProps.code
      //  , nextProps
    );
    this.setState({ prefixValidate: nextProps.code.includes('mundial') });


    const miscontenidosNode = Utils.getMisContenidosNode()

    if(modalRecordSeriesContent) {
      this.setState({ ribbons: [] })
      this.reloadMisContenidos(miscontenidosNode)
      setReloadMisContenidos(false)
      this.updateStatePlayerModalRecordings()

    }

    if (getReloadMisContenidos()) {
      if(nextProps.code === this.props.code && this.props.code === miscontenidosNode) {
        this.reloadMisContenidos(miscontenidosNode)
      }
      setReloadMisContenidos(false)
    }
    setReloadMisContenidos(false)

    const visibilityButtonFilter = this.props.code !== nextProps.code ? true : false;

    if (this.state.buttonFilter && visibilityButtonFilter) {
      switch(nextProps.code) {
        case nextProps.code:
          this.setState({ buttonFilter: false });
          break
        default:
          break
      }
    }

    if (this.props.code !== nextProps.code) {
      const node = nextProps.code || 'homeuser';
      const userStatus = this.resolveUserLogin();

      const isMundialNode = this.isMundialNode(nextProps);
      this.request(node, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels, isMundialNode);
      this.ribbonsCategories = RibbonsUtil.getRibbonsCategories(nextProps.code, nextProps.nodes);

      return true;
    }

    return false;
  }

  isMundialNode(nextProps) {
    let layout;
    if (!nextProps.appBehaviour) {
      layout = null;
    } else {
      layout = nextProps.appBehaviour.layout;
    }
    if(layout === 'mundial') return true;
    if(!Array.isArray(nextProps.nodes)) return false;
    const isChildMundial = this.isChildMundialNode(nextProps, nextProps.code);

    return isChildMundial;
  }

  isChildMundialNode(nextProps, currentCode) {
    let isMundial = false;
    if(!Array.isArray(nextProps.nodes)) return false;
    for(let i = 0; i < nextProps.nodes.length; i++) {
      let cnode = nextProps.nodes[i];
      if (cnode.app_behaviour && cnode.app_behaviour !== null) {
        const app_behaviour = JSON.parse(cnode.app_behaviour);
        if (app_behaviour && app_behaviour.layout && app_behaviour.layout === 'mundial') {
          if(cnode.childs && Array.isArray(cnode.childs)) {
            for(let j = 0; j < cnode.childs.length; j++) {
              let subnode = cnode.childs[j];
              if(subnode.code === currentCode) {
                isMundial = true;
                break;
              }
            }
          }
        }
      }
      if(isMundial) break;
    }

    return isMundial;
  }

  reloadMisContenidos(node){
    const userStatus = this.resolveUserLogin();
    this.request(node, userStatus);
  }

  handleKeyPress(e) {
    const { buttonFilter } = this.state;
    const pathname = window.location.pathname.split('/');
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

    if (Utils.keyBloquedInPTV(pathname, currentKey)) {
      return;
    }

    const isplaying = LayersControl.isPlayerVisible();

    if (isplaying && currentKey === 'RED') return;

    if (!Utils.isModalHide()) {
      return;
    }

    switch (currentKey) {
      case 'RED':
        if (buttonFilter) {
          this.onModalFilter()
        }
        break;
      default:
        break;
    }
  }

  addEventListeners() {
    document.addEventListener('keydown', this.handleKeyPress, true);
    document.addEventListener(settings.button_filter, this.updateOrder, true);
  }

  removeEventListeners() {
    document.addEventListener('keydown', this.handleKeyPress, true);
  }



  initRequests = () => {
    const node = this.props.code || 'homeuser';
    const userStatus = this.resolveUserLogin();
    const showNode = this.onShowNode(this.props.appBehaviour);
    const nodeHome = this.getLinks().home;
    const isMundial = this.isMundialNode(this.props)

    if (showNode) {
      this.request(node, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels, isMundial);
    } else {
      this.request(nodeHome, userStatus, this.props.updateFavoriteVOD, this.props.updateFavoriteChannels);
    }
  }

  forceUpdateGrid = () => {
    this.initRequests();
  }

  onShowNode(app_behaviour) {
    const { user: { isLoggedIn } = {} } = this.props;
    if (app_behaviour){
      const {node_config: {vis : {anon = 1, loggedin = 1} = {}} = {}} = app_behaviour || {};
      return isLoggedIn ? loggedin === 1:  anon === 1;;
    } else {
      return true
    }
  }

  getLinks() {
    return getLinksFromNavConfiguration();
  }

  resolveUserLogin() {
    let userType = 'anonymous';
    if (this.props.user.isLoggedIn && this.props.user.superhighlight) {
      userType = this.props.user.superhighlight.join();
    }
    return userType;
  }

  getShowCarruselSoccerWorldCup(resp){
    const showSoccerWorldCupKey = showSoccerWorldCup();
    if(showSoccerWorldCupKey.enable){
      return resp;
    }else{
       resp.components = resp.components = resp.components.filter(ribbon => (ribbon.type !== MUNDIALSOCCERMATCHER && ribbon.type !== MUNDIALSOCCERTEAMS))
      return resp;
    }
  }

  request(node, userStatus, callBackVOD, callBackChannels, isMundial) {
    const element = document.getElementsByClassName('app-profile-none');
    if(isMundial) {
      this.setState({ribbons: [], forceUpdateMundial: node  });
      return;
    }

    let rb = new RibbonsUtil();
    rb.getMiddlewareRibbons(node, userStatus, (resp) => {
      const infiniteList = resp.gridType !== 'ribbons';
      resp = this.getShowCarruselSoccerWorldCup(resp);
      const ribbons = resp.components;
      console.info('[HOME] entre', resp);
      resp.components.map(items => {
        if (items.ordenamiento) {
          this.setState({
            buttonFilter: true,
            orderItems: items.ordenamiento
          })
        }
      })


      //Separar sección "Mis Canales" y "Mis Contenidos"
      //https://dlatvarg.atlassian.net/browse/STV-5154
      /*let insertIndex = false;

      if (ribbons) {
        ribbons.map((item, index) => {
          if (item.id === 'porver') {
            insertIndex = index;
          }
        });

        if (insertIndex) {
          ribbons.splice(insertIndex + 1, 0, {
            id: 'canales_porver',
            title: 'Mis Canales',
            type: 'landscape',
          });
        }
      }


      this.setState({ ribbons, infiniteList });
      */
      const _this = this;
      const usrhash = store.getState().user.session_userhash;
      if (resp.byUser && (this.userHash || usrhash)) {
        /*
        //Actualizar informacion de favoritos
        if (callBackVOD && typeof callBackVOD === 'function' && callBackChannels && typeof callBackChannels === 'function') {
          callBackVOD();
          callBackChannels();
        }
        */
        rb.getUserMiddlewareRibbons(node, userStatus, (resp) => {
          const ribbonsUser = resp.components;
          const ribbons_show_delete_button = Utils.getRegionaliazedMetadata('ribbons_show_delete_button', '{"default":{"lastseen":{"enable":true,"type":["Actividad-reciente","actividadreciente","Continua-viendo","continuaviendo", "Recien-visto"]},"favorite":{"enable":true,"type":["Por-ver","porver","porver-live","porver-vod"]}}}');
          if(ribbonsUser){
          ribbonsUser.map((it) => {
            if(it.title) {
              if(it.title.includes('home_user_recome2one_one_title')) {
                it.title = it.title.replace('home_user_recome2one_one_title', Translator.get('home_user_recome2one_one_title', 'Sugerencias para ti'));
              }
              if(it.title.includes('home_user_recome2one_first_title')) {
                it.title = it.title.replace('home_user_recome2one_first_title', Translator.get('home_user_recome2one_first_title', 'Porque viste'));
              }
              if(it.title.includes('home_user_recome2one_second_title')) {
                it.title = it.title.replace('home_user_recome2one_second_title', Translator.get('home_user_recome2one_second_title', 'te recomendamos'));
              }
            }
            it.showFooter = Object
              .values(ribbons_show_delete_button)
              .some(activity => activity.enable && activity.type.includes(it.id));
            return it;
          })};
          this.setState({ribbons, ribbonsUser, infiniteList: false}, () => {
            _this.callBackFire()
          });
        }, this.props.user && this.props.user.user_token ? this.props.user.user_token : null, () => {
          this.setState({ribbons, infiniteList}, () => {
            _this.callBackFire()
          });
        });
      } else {
        this.setState({ribbons, ribbonsUser: null, infiniteList}, () => {
          _this.callBackFire()
        });
      }

      console.info('[HOME] getMiddlewareRibbons after setState');
      element[0].style['display']= 'none';
    }, null, () => {
      _this.callBackFire()
    });
  }

  callBackFire = () => {
    if (!LoadingIptvOttFlow.isLoadLive()) {
      LiveObserver.fire();
    }
  }

  onModalFilter () {
    const { orderItems } = this.state;
    const modal = {
      modalType: MODAL_FILTER,
      modalProps: {
        orderItems: orderItems
      }
    };
    store.dispatch(showModal(modal));
  }

  updateCardFromRibbonUser = ({ action = "", ribbonIds = [], cardGroupId = null, card = null }) => {
    const { ribbonsUser  = [] } = this.state;
      const newRibbonsUser = ribbonsUser.map( _ribbon => {
        const ribbon = {..._ribbon};
        if( Array.isArray(ribbonIds) && ribbon.id && ribbonIds.includes(ribbon.id) && Array.isArray(ribbon.items)) {
          if(action === ADD_CARD && card){
            ribbon.items.unshift(card);
          }
          else if( action === DELETE_CARD){
            ribbon.items = ribbon.items.filter(it => {
              if(it.isRecord){
                return it.event_id !== cardGroupId;
              }else{
                if(it.isSeries && it.ext_series_id){
                  return it.ext_series_id !== cardGroupId;
                }else{
                  return it.group_id !== cardGroupId;
                }
              }
            });
          }else if(action === UPDATE_CARD){
            ribbon.items = ribbon.items.filter(it => {
              if(it.isSeries && it.ext_series_id && it.ext_series_id === cardGroupId && it.numEpisodes &&  card.numEpisodesNew){
                  it.numEpisodes = card.numEpisodesNew;
                  const element = document.getElementById(`serie_${cardGroupId}`);
                  if(element && element.innerText){
                    element.innerText = Utils.numberEpisodesCardRecordings(card.numEpisodesNew);
                  }
              }
              return it;
            });
          }
        }
        return ribbon;
      });

      this.setState({
        ribbonsUser: newRibbonsUser
      });
  }

  updateOrder (order) {
    this.setState({ order: order.detail})
  }

  render() {
    const {
      showRibbonWhenMount,
      buttonFilter,
      order,
      prefixValidate
    } = this.state;
    setReloadMisContenidos(false)
    const { code, nodes } = this.props;
    console.info('[Home] render ',
      '\nthis.props.code', this.props.code,
      '\nthis.props.user', this.props.user
    );
    const userStatus = this.resolveUserLogin();
    if(code.includes('mundial')) {
      nodes.forEach((n) => {
        if (n.childs && n.childs.find(c => c.code === code)) {
          this.prefixCode = n.code;
        } else if (n.code === code) {
          this.prefixCode = n.code;
        }
      });
    }
    return (
      showRibbonWhenMount ?
        <div className="home-container">
          {buttonFilter && <div className={'horizontal-bar'}></div>}
          {(prefixValidate || code.includes('mundial')) ? <img className='highlight-mundial' src={asset.get(`${this.prefixCode}_homeAddon_header_img`)} alt='highlight worldcup'/> : buttonFilter && !Utils.getHasClaroMusicaNode() && <ButtonFilter
            navigation = {{
              up: '#aaf_menu-container-center .active.focusable',
              down: '.container-infinite-list a.focusable',
            }}
            onModalFilter={this.onModalFilter}
          />
          }
          {this.state.infiniteList && <InfiniteList
            order={order}
            user={this.props.user}
            level={this.props.code}
            setMetricsEvent={this.props.setMetricsEvent}
            ribbonsCategories={this.ribbonsCategories}
            buttonFilter={Utils.getHasClaroMusicaNode() && buttonFilter}>
            <ButtonFilter
              navigation = {{
                up: '#aaf_menu-container-center .active.focusable',
                down: '.container-infinite-list a.focusable',
              }}
              onModalFilter={this.onModalFilter}
            />
            </InfiniteList>}
          {!this.state.infiniteList && <RibbonGrid
            // El middleware manda al ribbon los titulos incorrectamente para noggin.
            ribbonsTypeMenu={this.state.ribbonsTypeMenu}
            ribbonsPrev={(prefixValidate || code.includes('mundial')) ? [] : this.state.ribbons}
            ribbonsUser={this.state.ribbonsUser}
            ribbonsCategories={this.ribbonsCategories}
            user={this.props.user}
            asset={asset}
            setMetricsEvent={this.props.setMetricsEvent}
            forceUpdateGrid={this.forceUpdateGrid}
            code={this.props.code}
          />}
        </div> : null
    )
  }
}

const mapStateToProps = state => ({user: state.user, player: state.player});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setMetricsEvent,
  showModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.jsx